<script>
  import Spark from "./Spark.svelte";
  import { LayerCake, Svg } from "layercake";
  import { extent } from "d3-array";

  let { data, height = 33 } = $props();

  const xKey = "date";
  // because we are always using the national value, and "00" acts as the id for the national data
  const yKey = "00";

  let yDomain = $derived(extent(data, (d) => (isNaN(d[yKey]) ? null : d[yKey])));
</script>

<div class="chart-container" style:--chart-height="{height}px">
  <LayerCake padding={{ top: 0, right: 0, bottom: 0, left: 0 }} x={xKey} y={yKey} {yDomain} {data}>
    <Svg>
      <Spark />
    </Svg>
  </LayerCake>
</div>

<style>
  /*
    The wrapper div needs to have an explicit width and height in CSS.
    It can also be a flexbox child or CSS grid element.
    The point being it needs dimensions since the <LayerCake> element will
    expand to fill it.
  */
  .chart-container {
    width: 100%;
    height: var(--chart-height, 33px);
  }
</style>
